"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectHierarchy = exports.SelectOptionItemNoBorder = exports.SelectOptionFirstWrapper = exports.SelectOptionItem = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../globalCss");
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var matching_1 = require("../../utils/matching");
var borderRadius_1 = require("../../utils/styled/borderRadius");
var mq_1 = require("../../utils/styled/mq");
var Common_1 = require("../Common");
var RadioButton_1 = require("../Common/RadioButton");
var SearchBox_1 = __importDefault(require("../Search/SearchBox"));
var SelectOption_1 = require("./SelectOption");
var SelectOptionHierarchy_1 = require("./SelectOptionHierarchy");
var SelectSharedComponents_1 = require("./SelectSharedComponents");
var SelectStyles_1 = require("./SelectStyles");
var SelectUtil_1 = require("./SelectUtil");
// SEARCH BOX CONTAINER
var SearchBoxContainer = styled_components_1.default.div.attrs({
    className: 'tws-select-searchbox-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 16px;\n\tborder-bottom: ", " ", " ", ";\n\t.tws-searchbox-input {\n\t\tmin-width: initial;\n\t}\n"], ["\n\tpadding: 16px;\n\tborder-bottom: ", " ", " ", ";\n\t.tws-searchbox-input {\n\t\tmin-width: initial;\n\t}\n"])), globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2);
// DISPLAY TEXT
var DisplayText = styled_components_1.default.div.attrs({
    className: 'display-text tws-display-text',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: ", ";\n\talign-self: ", ";\n\tmargin-left: 16px;\n\tmargin-right: 16px;\n\tflex: 1 1 auto;\n\twhite-space: nowrap;\n\toverflow: hidden;\n"], ["\n\tdisplay: ", ";\n\talign-self: ", ";\n\tmargin-left: 16px;\n\tmargin-right: 16px;\n\tflex: 1 1 auto;\n\twhite-space: nowrap;\n\toverflow: hidden;\n"])), globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter);
DisplayText.displayName = 'DisplayText';
// SELECT CONTAINER
var SelectContainer = styled_components_1.default.div.attrs({
    className: 'select-container tws-select-container',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tbox-sizing: border-box;\n\tdisplay: ", ";\n\tcursor: pointer;\n\tborder: ", " ", " ", ";\n\tborder-radius: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-size: 13px;\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n"], ["\n\tbox-sizing: border-box;\n\tdisplay: ", ";\n\tcursor: pointer;\n\tborder: ", " ", " ", ";\n\tborder-radius: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tfont-size: 13px;\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n"])), globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2, globalVars_module_scss_1.default.borderRadius3, globalVars_module_scss_1.default.gray10, globalVars_module_scss_1.default.secondaryGray1, function (props) { return (0, SelectStyles_1.selectStyles)(props.size, props.selectSize); }, function (props) {
    return props.disabled
        ? "background-color: ".concat(globalVars_module_scss_1.default.gray9, "; \n\t\tborder-color: ").concat(globalVars_module_scss_1.default.gray9, ";\n\t\tcolor: #bbbbbb;\n\t\tborder: ").concat(globalVars_module_scss_1.default.border0, ";\n\t\tcursor: default;")
        : null;
}, function (props) { return (props.selectedState ? "background-color: ".concat(globalVars_module_scss_1.default.white, " !important; color: ").concat(globalVars_module_scss_1.default.mainGray, " !important;") : null); }, function (props) { return (props.focus ? "background-color: ".concat(globalVars_module_scss_1.default.tertiaryGray3, " !important; color: ").concat(globalVars_module_scss_1.default.mainGray, ";") : null); }, (0, mq_1.lessThan)('large')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t"], ["\n\t\twidth: 100%;\n\t"]))));
SelectContainer.displayName = 'SelectContainer';
// SELECT COUNT
var SelectedCount = styled_components_1.default.div.attrs({
    className: 'selected-count tws-select-count',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tdisplay: ", ";\n\talign-self: ", ";\n\tmargin-right: 8px;\n\t", "\n"], ["\n\tdisplay: ", ";\n\talign-self: ", ";\n\tmargin-right: 8px;\n\t", "\n"])), globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter, function (props) { return (0, SelectStyles_1.selectCountStyles)(props.size); });
SelectedCount.displayName = 'SelectedCount';
// OPTION ITEM: SELECT
exports.SelectOptionItem = (0, styled_components_1.default)(SelectOption_1.SelectOption).attrs({
    className: 'options-item tws-select-options-item',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
exports.SelectOptionItem.displayName = 'SelectOptionItem';
exports.SelectOptionFirstWrapper = styled_components_1.default.div.attrs({
    className: 'tws-select-first-option-item',
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t&.tws-select-first-option-item .tws-option-item {\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\t&.tws-select-first-option-item .tws-option-item {\n\t\tbackground-color: ", ";\n\t}\n"])), globalVars_module_scss_1.default.secondaryBlue);
exports.SelectOptionFirstWrapper.displayName = 'SelectOptionFirstWrapper';
var SelectOptionItemWrapper = styled_components_1.default.div.attrs({
    className: 'tws-select-options-item-2',
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t&.tws-select-options-item-2 .tws-option-item {\n\t\tpadding-left: ", "px !important;\n\t\t&:last-child {\n\t\t\tborder-bottom: ", " ", " ", ";\n\t\t}\n\t\tbackground-color: transparent;\n\t}\n"], ["\n\t&.tws-select-options-item-2 .tws-option-item {\n\t\tpadding-left: ", "px !important;\n\t\t&:last-child {\n\t\t\tborder-bottom: ", " ", " ", ";\n\t\t}\n\t\tbackground-color: transparent;\n\t}\n"])), function (props) { return 16 * props.level; }, globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2);
SelectOptionItemWrapper.displayName = 'SelectOptionItemWrapper';
exports.SelectOptionItemNoBorder = styled_components_1.default.div.attrs({
    className: 'tws-select-options-item-2',
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t&.tws-select-options-item-2 .tws-option-item {\n\t\tborder-bottom: 0;\n\t\tbackground-color: transparent;\n\t}\n"], ["\n\t&.tws-select-options-item-2 .tws-option-item {\n\t\tborder-bottom: 0;\n\t\tbackground-color: transparent;\n\t}\n"])));
exports.SelectOptionItemNoBorder.displayName = 'SelectOptionItemNoBorder';
var Message = styled_components_1.default.ul.attrs({
    className: 'input-message tws-input-validation-message-wrapper',
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n\tpadding: ", ";\n\t", ";\n\tli {\n\t\tlist-style: none;\n\t}\n"], ["\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n\tpadding: ", ";\n\t", ";\n\tli {\n\t\tlist-style: none;\n\t}\n"])), globalVars_module_scss_1.default.spacing0, globalCss_1.bodyCopyXSmall);
Message.displayName = 'Message';
var ErrorMessage = (0, styled_components_1.default)(Message)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n\tmin-height: 20px;\n\tcolor: ", ";\n\tline-height: 1.1em;\n"], ["\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n\tmin-height: 20px;\n\tcolor: ", ";\n\tline-height: 1.1em;\n"])), globalVars_module_scss_1.default.tertiaryRed);
ErrorMessage.displayName = 'ErrorMessage';
var SuccessMessage = (0, styled_components_1.default)(Message)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n\tmin-height: 20px;\n\tcolor: ", ";\n\tline-height: 1.1em;\n"], ["\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n\tmin-height: 20px;\n\tcolor: ", ";\n\tline-height: 1.1em;\n"])), globalVars_module_scss_1.default.secondaryGreen);
SuccessMessage.displayName = 'SuccessMessage';
// SELECT TOGGLE
var SelectToggle = styled_components_1.default.div.attrs({
    className: 'select-toggle tws-select-toggle',
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\t", "\n\t", "\n\tcolor: ", ";\n\tdisplay: ", ";\n\talign-items: ", ";\n\tjustify-content: center;\n\t", "\n\t", "\n\tflex: 1 0 auto;\n\ti {\n\t\tz-index: 3;\n\t}\n"], ["\n\t", "\n\t", "\n\tcolor: ", ";\n\tdisplay: ", ";\n\talign-items: ", ";\n\tjustify-content: center;\n\t", "\n\t", "\n\tflex: 1 0 auto;\n\ti {\n\t\tz-index: 3;\n\t}\n"])), function (props) {
    return props.disabled
        ? "background: ".concat(globalVars_module_scss_1.default.gray7, "; cursor: default;")
        : "background: ".concat(globalVars_module_scss_1.default.mainBlue, "; margin-right: -1px; margin-top: -1px;");
}, function (props) { return (props.focus ? 'background: #04667C;' : ''); }, globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter, function (props) { return (0, SelectStyles_1.selectToggleStyles)(props.size); }, (0, borderRadius_1.borderRightRadius)('3px'));
SelectToggle.displayName = 'SelectToggle';
var SelectHierarchy = /** @class */ (function (_super) {
    __extends(SelectHierarchy, _super);
    function SelectHierarchy(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = false;
        _this.radioItems = [];
        _this.state = {
            items: _this.props.items ? __spreadArray([], _this.props.items, true) : [],
            open: false,
            displayText: _this.props.displayText,
            selectedValue: _this.props.selectedValue || '',
            initialSearchText: _this.props.initialSearchText,
        };
        _this.originalList = lodash_1.default.cloneDeep(_this.state.items);
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.handleOnFocus = _this.handleOnFocus.bind(_this);
        _this.handleRadioButtonChange = _this.handleRadioButtonChange.bind(_this);
        _this.toggleDropdown = _this.toggleDropdown.bind(_this);
        _this.updateSearch = _this.updateSearch.bind(_this);
        _this.generateRadioOptions = _this.generateRadioOptions.bind(_this);
        _this.isSelected = _this.isSelected.bind(_this);
        _this.selectionRef = React.createRef();
        return _this;
    }
    SelectHierarchy.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({
            selectedValue: nextProps.selectedValue || '',
            items: nextProps.items ? nextProps.items : [],
        });
        this.originalList = lodash_1.default.cloneDeep(nextProps.items ? nextProps.items : []);
        this.updateSearch(this.state.initialSearchText ? this.state.initialSearchText : '');
    };
    SelectHierarchy.prototype.componentWillUnmount = function () {
        this.clearFocusTime();
        this.clearBlurTime();
    };
    SelectHierarchy.prototype.updateSearch = function (searchText) {
        var _this = this;
        var filteredOptions;
        var parentOptions = [];
        if (searchText === '') {
            filteredOptions = this.originalList;
        }
        else {
            filteredOptions = lodash_1.default.filter(this.originalList, function (option) {
                return matching_1.MatchingUtil.testObjectMatch(option, searchText, ['displayText']);
            });
            lodash_1.default.forEach(filteredOptions, function (option) {
                if (option.parentId !== undefined && option.parentId !== null) {
                    var parent_1 = lodash_1.default.find(_this.originalList, { id: option.parentId });
                    if (parent_1) {
                        parentOptions.push.apply(parentOptions, _this.addBackParents(parent_1));
                    }
                }
            });
            filteredOptions = lodash_1.default.union(filteredOptions, parentOptions);
        }
        // refresh the dropdown list
        this.setState({ items: filteredOptions, initialSearchText: searchText });
    };
    SelectHierarchy.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(SelectSharedComponents_1.Container, { className: this.props.className, tabIndex: 1, ref: this.selectionRef, selectWidth: SelectUtil_1.SelectUtil.getSelectWidth(this.props.selectWidth, this.props.selectSize), onBlur: this.handleOnBlur, onFocus: this.handleOnFocus },
                React.createElement(SelectContainer, { onClick: this.toggleDropdown, selectWidth: this.props.selectWidth, size: this.props.size, selectSize: this.props.selectSize, disabled: this.props.disabled, focus: this.focus, error: this.props.error },
                    React.createElement(DisplayText, null, this.getDisplayText()),
                    React.createElement(SelectToggle, { disabled: this.props.disabled, focus: this.focus, size: this.props.size },
                        React.createElement(Common_1.Icon, { name: 'caret-down' }))),
                this.generateDropdown()),
            this.props.message && this.getExtraMessage()));
    };
    SelectHierarchy.prototype.addBackParents = function (option) {
        var parents = [];
        if (option.parentId !== undefined && option.parentId !== null) {
            var parent_2 = lodash_1.default.find(this.originalList, { id: option.parentId });
            if (parent_2) {
                parents.push.apply(parents, this.addBackParents(parent_2));
            }
        }
        parents.push(option);
        return parents;
    };
    SelectHierarchy.prototype.getExtraMessage = function () {
        var message = this.props.message;
        var messages = typeof message === 'string' ? [this.props.message] : message;
        var extraMessages = messages.map(function (m, index) {
            return React.createElement("li", { key: 'input-message-' + index }, m);
        });
        if (this.props.error) {
            return React.createElement(ErrorMessage, null, extraMessages);
        }
        else if (this.props.success) {
            return React.createElement(SuccessMessage, null, extraMessages);
        }
        return null;
    };
    SelectHierarchy.prototype.generateDropdown = function () {
        if (!this.state.open) {
            return React.createElement("span", null);
        }
        return (React.createElement(SelectSharedComponents_1.DropdownContainer, { optionsContainerWidth: this.props.optionsContainerWidth, selectWidth: SelectUtil_1.SelectUtil.getSelectWidth(this.props.selectWidth, this.props.selectSize), dropdownSize: this.props.dropdownSize },
            this.props.showSearch && !this.props.hasGroups && (React.createElement(SearchBoxContainer, null,
                React.createElement(SearchBox_1.default, { callbackFunc: this.updateSearch, resultsCount: this.state.items.length, inputSize: 'sm', initialSearchText: this.state.initialSearchText, placeHolderText: this.props.placeHolderText }))),
            React.createElement(SelectSharedComponents_1.OptionsContainer, { showSearch: this.props.showSearch, hasGroups: this.props.hasGroups },
                this.generateFirstOption(),
                this.generateRadioOptions())));
    };
    SelectHierarchy.prototype.generateRadioOptions = function () {
        var _this = this;
        var hierarchyItems = this.groupOptions(this.state.items);
        if (hierarchyItems.length > 0) {
            var orderedHierarchyItems = lodash_1.default.orderBy(hierarchyItems, ['item.displayOrder'], ['asc']);
            return this.generateNodes(orderedHierarchyItems, 0);
        }
        else {
            return this.state.items.map(function (item) {
                _this.generateRadioOption(item);
            });
        }
    };
    SelectHierarchy.prototype.generateFirstOption = function () {
        if (this.props.firstItem) {
            return React.createElement(exports.SelectOptionFirstWrapper, null, this.generateRadioOption(this.props.firstItem));
        }
        return;
    };
    SelectHierarchy.prototype.generateNodes = function (items, level) {
        var _this = this;
        return items.map(function (item, index) {
            if (item.children.length > 0) {
                return (React.createElement(SelectOptionHierarchy_1.SelectOptionHierarchy, { IsSelected: _this.isSelected, isChecked: _this.state.selectedValue === item.item.name, HandleRadioButtonChange: _this.handleRadioButtonChange, item: item.item, level: level, key: "group-".concat(index), collapsed: true }, _this.generateNodes(item.children, level + 1)));
            }
            else {
                return (React.createElement(SelectOptionItemWrapper, { key: "item-".concat(index), level: level }, _this.generateRadioOption(item.item)));
            }
        });
    };
    SelectHierarchy.prototype.generateRadioOption = function (item) {
        var _this = this;
        var radioOption = {
            name: item.name,
            displayText: item.displayText,
            checked: this.state.selectedValue === item.name,
        };
        return (React.createElement(exports.SelectOptionItem, { item: item, selected: this.isSelected(radioOption.name), key: radioOption.name },
            React.createElement(RadioButton_1.RadioButton, { groupName: 'selectGrp', isChecked: radioOption.checked ? radioOption.checked : false, key: radioOption.name, size: 'sm', item: radioOption, handleChange: function () { return _this.handleRadioButtonChange(radioOption.name); }, showTooltips: false })));
    };
    SelectHierarchy.prototype.groupOptions = function (options) {
        var flatArray = options.map(function (option) {
            return { item: option, children: [] };
        });
        (0, lodash_1.default)(flatArray).forEach(function (f) {
            f.children = (0, lodash_1.default)(flatArray)
                .filter(function (g) { return g.item.parentId === f.item.id; })
                .value();
        });
        var resultArray = (0, lodash_1.default)(flatArray)
            .filter(function (f) { return f.item.parentId === undefined || f.item.parentId === null; })
            .value();
        return resultArray;
    };
    SelectHierarchy.prototype.getDisplayText = function () {
        var displayText = this.state.displayText;
        if (this.state.selectedValue) {
            var selectedItem = lodash_1.default.find(this.originalList, { name: this.state.selectedValue });
            if (selectedItem) {
                displayText = selectedItem.displayText;
            }
            else if (this.props.firstItem) {
                displayText = this.props.firstItem.name === this.state.selectedValue ? this.props.firstItem.displayText : displayText;
            }
        }
        return displayText;
    };
    SelectHierarchy.prototype.handleRadioButtonChange = function (value) {
        this.setState({ selectedValue: value });
        if (this.props.onRadioChange) {
            this.props.onRadioChange(value);
        }
    };
    // function should only be called by the click event on the select container
    SelectHierarchy.prototype.toggleDropdown = function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.props.disabled) {
            return;
        }
        this.setOpenState(!this.state.open, !this.state.open);
    };
    SelectHierarchy.prototype.setOpenState = function (open, needFocus) {
        var _this = this;
        if (this.state.open === open) {
            this.maybeFocus(open, needFocus);
            return;
        }
        if (this.props.onDropdownVisibleChange) {
            this.props.onDropdownVisibleChange(open);
        }
        if (!open) {
            this.maybeFocus(open, needFocus);
        }
        this.focus = open;
        var nextState = {
            open: open,
        };
        this.setState(nextState, function () {
            if (open) {
                _this.maybeFocus(open, needFocus);
            }
        });
    };
    SelectHierarchy.prototype.maybeFocus = function (open, needFocus) {
        var _this = this;
        if (needFocus || open) {
            var activeElement = document.activeElement;
            if (this.selectionRef && activeElement !== this.selectionRef) {
                this.focusTimer = setTimeout(function () {
                    _this.selectionRef.current.focus();
                    _this.focus = true;
                }, 10);
            }
        }
    };
    SelectHierarchy.prototype.timeoutFocus = function () {
        var _this = this;
        if (this.focusTimer) {
            this.clearFocusTime();
        }
        if (this.props.onFocus) {
            this.focusTimer = setTimeout(function () {
                _this.props.onFocus();
            }, 10);
        }
    };
    SelectHierarchy.prototype.clearFocusTime = function () {
        if (this.focusTimer) {
            clearTimeout(this.focusTimer);
            this.focusTimer = null;
        }
    };
    SelectHierarchy.prototype.clearBlurTime = function () {
        if (this.blurTimer) {
            clearTimeout(this.blurTimer);
            this.blurTimer = null;
        }
    };
    SelectHierarchy.prototype.handleOnBlur = function () {
        var _this = this;
        this.blurTimer = setTimeout(function () {
            _this.setOpenState(false, false);
        }, 10);
    };
    SelectHierarchy.prototype.handleOnFocus = function (e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        this.clearBlurTime();
        this.timeoutFocus();
    };
    SelectHierarchy.prototype.isSelected = function (name) {
        return this.state.selectedValue === name;
    };
    // Default props
    SelectHierarchy.defaultProps = {
        selectWidth: 'auto',
        optionsContainerWidth: '100%',
    };
    return SelectHierarchy;
}(React.Component));
exports.SelectHierarchy = SelectHierarchy;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
